import Layout from '../../../../../common/components/layout/Layout';
import Header from '../../../../../common/components/layout/Header';
import PaymentLabels from '../../../../../common/components/modules/sports/PaymentLabels';
import LayoutInside from '../../../../../common/components/layout/LayoutInside';
import { useLocation } from 'react-router-dom';
import MsjSuccess from '../../../../../common/components/sections/MsjSuccess';
import { attributesBySport } from '../../../../../common/data/attributes';
import { useCallback, useEffect, useState } from 'react';
import { getModel2 } from '../../../../../services/payment.service';
import Loading from '../../../../../common/loading/Loading';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

type GetClubAndFieldFromReservation = {
    transactionStatus: string;
    reservationId: string;
    reservationStart: string;
    reservationEnd: string;
    fieldId: string;
    fieldName: string;
    fieldDescription: string | null;
    clubId: string;
    clubName: string;
    clubAddress: string;
    clubPhoto: string | null;
    clubLogo: string;
    amount: number;
};

const ClubsPayment = (): JSX.Element => {
    const attribute = attributesBySport('rent');
    const query = useQuery();
    const id = query.get('id');
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState<GetClubAndFieldFromReservation | undefined>(undefined);

    const confirmPayment = useCallback(async () => {
        try {
            const transaction = await getModel2(`transactions/order/${id}`);

            if (transaction && transaction.data) {
                if (
                    transaction.data.transactionStatus === 'INITIALIZED' ||
                    transaction.data.transactionStatus === 'AUTHORIZED'
                ) {
                    setData(transaction.data);
                    setSuccess(true);
                    setIsLoading(false);
                    setError(false);
                } else {
                    setError(true);
                    setIsLoading(false);
                    setSuccess(false);
                }
            } else {
                setError(true);
                setIsLoading(false);
                setSuccess(false);
            }
        } catch (error) {
            setSuccess(false);
            setError(true);
            setIsLoading(false);
        }

        setIsLoading(false);
    }, [id]);

    useEffect(() => {
        if (id && !isLoading && !success && !error) {
            setIsLoading(true);
            setSuccess(false);
            setError(false);
            confirmPayment();
        }

        if (!id) {
            setIsLoading(false);
            setError(true);
        }
    }, [id, isLoading, success, error, confirmPayment]);

    // First, handle loading state
    if (isLoading) {
        return <Loading />;
    }

    // Then handle error state
    if (error) {
        return (
            <Layout navProps={{ title: 'Hubo un problema con el Pago | Supermatch', description: 'Pago Supermatch' }}>
                <>
                    <Header />
                    <LayoutInside attribute={attribute} title={'Error'} subTitle={''}>
                        <div className="flex flex-col justify-center items-center">
                            <div className="bg-white pt-5 w-full md:w-2/5 lg:w-2/5 sm:bg-opacity-50 sm:shadow-lg rounded-lg">
                                <div className="text-center p-6">
                                    <h3 className="text-xl font-bold text-red-600 mb-4">
                                        Hubo un problema con el pago
                                    </h3>
                                    <p>Por favor, intente nuevamente más tarde.</p>
                                </div>
                            </div>
                        </div>
                    </LayoutInside>
                </>
            </Layout>
        );
    }

    // Finally handle success state
    if (success && data) {
        return (
            <Layout navProps={{ title: 'Pago Confirmado | Supermatch', description: 'Pago Supermatch' }}>
                <>
                    <Header />
                    <LayoutInside attribute={attribute} title={'Resumen'} subTitle={''}>
                        <div className="flex flex-col justify-center items-center ">
                            <div className="bg-white pt-5 w-full md:w-2/5 lg:w-2/5  sm:bg-opacity-50   sm:shadow-lg rounded-lg">
                                <div className="flex flex-col mx-auto w-full  mt-0  md:px-10 lg:px-10">
                                    <div className="w-full md:w-full px-10 md:px-0 pb-10 md:pb-0 text-center">
                                        {data && (
                                            <>
                                                <h3 className="text-xl font-bold italic text-sm-gray-1 mb-5 py-2">
                                                    Pago completado para la {data.fieldName}
                                                </h3>
                                                {/* <PaymentLabels title="Nombre" value={data?.userName} />
                                                <PaymentLabels title="Email" value={data?.userEmail} /> */}
                                                {/* <PaymentLabels title="Teléfono" value={data?.phone} /> */}
                                                <PaymentLabels
                                                    title="Fecha"
                                                    value={`${new Date(data?.reservationStart).toLocaleDateString(
                                                        'es-CL',
                                                    )}`}
                                                />
                                                <PaymentLabels
                                                    title="Desde"
                                                    value={`${new Date(data?.reservationStart)
                                                        .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                                        .replace(' AM', '')
                                                        .replace(' PM', '')} Hrs`}
                                                />
                                                <PaymentLabels
                                                    title="Hasta"
                                                    value={`${new Date(data?.reservationEnd)
                                                        .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                                        .replace(' AM', '')
                                                        .replace(' PM', '')} Hrs`}
                                                />
                                                <PaymentLabels title="Club" value={`${data?.clubName}`} />
                                                <PaymentLabels title="Cancha" value={`${data?.fieldName}`} />
                                            </>
                                        )}
                                    </div>
                                </div>
                                <div className={'pt-4 '}>
                                    <MsjSuccess className={' top-0 bg-sm-rent '} classSecondary={'md:w-1/2 lg:w-2/3'}>
                                        <>
                                            <p className="pt-5 text-center text-2xl font-bold italic"> Gracias</p>
                                            <p className="">_________________________</p>
                                            <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                                Total pagado
                                            </p>
                                            {data?.amount && (
                                                <p className="text-4xl pt-4 font-bold italic text-white">{`${parseInt(
                                                    data?.amount.toString(),
                                                ).toLocaleString('es-CL', { style: 'currency', currency: 'CLP' })}`}</p>
                                            )}
                                        </>
                                    </MsjSuccess>
                                </div>
                            </div>
                        </div>
                    </LayoutInside>
                </>
            </Layout>
        );
    }

    // Fallback loading state
    return <Loading />;
};

export default ClubsPayment;
